export default {
    configuration: false,
    searchList: {
        searchTxt: [
            {
                name: '发车单号',
                value: 'dispatchNo',
                type: 'input',
                unfold: true,
                span: 4
            },
            {
                name: '服务平台',
                value: 'siteName',
                unfold: true,
                multiple: true,
                border: true,
                maxSelect: 10,
                dialogWidth: '800px',
                multipleTableColumn: {
                    prop: 'escoCompanyNameCn', 'value': '服务平台名称'
                },
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'escoCompanyNo', value: '服务平台编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' }
                ],
                advanceUrl: '/searchPlatform',
                cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                advanceCascade: 'companyCode',
                type: 'advance',
                span: 4
            },
            {
                name: '客户',
                value: 'customerName',
                prop: 'customerName',
                type: 'advance',
                readOnly: false,
                multiple: true,
                maxSelect: 5,
                border: true,
                dialogWidth: '800px',
                multipleTableColumn: {
                    prop: 'ebcuNameCn', 'value': '客户名称'
                },
                advanceConfig: [
                    { prop: 'ebcuNameCn', value: '客户名称' },
                    { prop: 'pmCode', value: '客户编码' }
                ],
                tableConfig: [
                    { prop: 'pmCode', value: '客户编码' },
                    { prop: 'ebcuNameCn', value: '客户名称' }
                ],
                cbParams: ['pmCode#customerCode', 'ebcuNameCn#customerName'],
                advanceUrl: '/ebCustomer/searchByEbCustomer',
                unfold: true,
                span: 4
            },
            {
                name: '预警状态',
                value: 'monitorStatus',
                type: 'select',
                optionNum: 'CHANGE_MONITOR_WARNING_STATUS',
                options: [],
                unfold: true,
                span: 3,
                multiple: true,
                data: ['1']

            },
            {
                name: '首次预警时间',
                value: 'firstMonitorTime',
                type: 'time',
                unfold: true,
                span: 6,
                timeNum: 6,
                startPlaceholder: '首次预警开始时间',
                endPlaceholder: '首次预警结束时间'
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        height: 400,
        leftOperation: true,
        leftWidth: 60,
        selectBtn: false,
        columns: [
            {
                label: '发车单号',
                prop: 'dispatchNo',
                sort: true,
                width: 160
            },
            {
                label: '司机名称',
                prop: 'driver',
                sort: true,
                width: 105
            },
            {
                label: '司机联系方式',
                prop: 'driverContactWay',
                sort: true,
                width: 130
            },
            {
                label: '调度人员',
                prop: 'dispatchCreateUserName',
                sort: true,
                width: 110
            },
            {
                label: '装卸方式',
                prop: 'loadingMethod',
                sort: true,
                width: 110
            },
            {
                label: '轨迹偏离次数',
                prop: 'trackOffCount',
                sort: true,
                width: 130
            },
            {
                label: '线路变更次数',
                prop: 'lineChangeCount',
                sort: true,
                width: 130
            },
            {
                label: '途径点异常次数',
                prop: 'pathAbnormalCount',
                sort: true,
                width: 140
            },
            {
                label: '抵达异常离场次数',
                prop: 'arriveExceptionExitCount',
                sort: true,
                width: 160
            },
            {
                label: '在途轨迹丢失次数',
                prop: 'onTheWayTrackLoseCount',
                sort: true,
                width: 160
            },
            {
                label: '未在目的地抵达次数',
                prop: 'notArriveDestinationCount',
                sort: true,
                width: 168
            },
            {
                label: '预警状态',
                prop: 'monitorStatus',
                type: 'select',
                optionNum: 'CHANGE_MONITOR_WARNING_STATUS',
                options: [],
                sort: true,
                width: 110
            },
            {
                label: '发车时间',
                prop: 'dispatchTime',
                sort: true,
                width: 160
            },
            {
                label: '首次预警时间',
                prop: 'firstMonitorTime',
                sort: true,
                width: 160
            },
            {
                label: '最新预警时间',
                prop: 'newMonitorTime',
                sort: true,
                width: 160
            },
            {
                label: '最新预警处理人',
                prop: 'newMonitorProcessor',
                sort: true,
                width: 142
            },
            {
                label: '最新处理预警时间',
                prop: 'newDisposeMonitorTime',
                sort: true,
                width: 165
            },
            {
                label: '承运商',
                prop: 'carrierName',
                sort: true,
                width: 160
            },
            {
                label: '采购渠道',
                prop: 'procurementChannel',
                type: 'select',
                optionNum: 'OTP_TMS_PROCUREMENT_CHANNEL',
                options: [],
                sort: true,
                width: 110
            },
            {
                label: '车牌号',
                sort: true,
                prop: 'vehicleCard',
                width: 100
            },
            {
                label: '专业公司',
                prop: 'professionalCompany',
                type: 'select',
                options: [],
                optionNum: 'JD_PROFESSIONAL_COMPANY',
                sort: true,
                width: 160
            },
            {
                label: '分公司',
                prop: 'companyName',
                sort: true,
                width: 160
            },
            {
                label: '经营中心',
                prop: 'centerName',
                width: 170,
                sort: true
            },
            {
                label: '服务平台',
                prop: 'siteName',
                sort: true,
                width: 160
            },
            {
                label: '发运类型',
                prop: 'shippingType',
                type: 'select',
                optionNum: 'TMS_SHIPPING_TYPE',
                options: [],
                sort: true,
                width: 110
            },
            {
                label: '行业',
                prop: '__industryCategory__',
                sort: true,
                width: 130
            },
            {
                label: '线路',
                prop: 'lineName',
                sort: true,
                width: 200
            },
            {
                label: '客户',
                prop: 'customerName',
                width: 280,
                sort: true
            },
            {
                label: '超长时间滞留次数',
                prop: 'extremelyLongTimeRetentionCount',
                width: 130
            },
            {
                label: '疲劳驾驶次数',
                prop: 'tiredDriveCount',
                width: 100
            }
        ],
        action: [
            {
                type: 'text',
                label: '查看',
                size: 'mini',
                event: 'viewDetail',
                ifHas: '/performance/collusion-warning/viewDetail'
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 20,
        pageSizes: [10, 20, 30, 50, 100]
    },
    searchTotalTitle: [
        {
            name: '分公司',
            value: 'companyName',
            type: 'advance',
            advanceConfig: [
                { prop: 'escoCompanyNameCn', value: '分公司名称' },
                { prop: 'escoCompanyNo', value: '分公司编码' }
            ],
            tableConfig: [
                { prop: 'escoCompanyNameCn', value: '分公司名称' },
                { prop: 'escoCompanyNo', value: '分公司编码' }
            ],
            advanceUrl: '/searchBrand',
            cbParams: [
                'escoCompanyNameCn#companyName',
                'escoCompanyNo#companyCode'
            ]
        },
        {
            method: 'post',
            name: '经营中心',
            value: 'centerName',
            disabled: false,
            type: 'advance',
            advanceConfig: [
                { prop: 'escoCompanyNameCn', value: '经营中心名称' },
                { prop: 'escoCompanyNo', value: '经营中心编码' }
            ],
            tableConfig: [
                { prop: 'escoCompanyNameCn', value: '经营中心名称' },
                { prop: 'escoCompanyNo', value: '经营中心编码' }
            ],
            prefix: '/api-opms/',
            advanceUrl: 'opms/management/queryManagementForMdm',
            cbParams: ['escoCompanyNo#centerCode', 'escoCompanyNameCn#centerName']
        },
        {
            name: '预警处理人',
            value: 'monitorProcessor',
            type: 'input'
        },
        {
            name: '发车时间',
            value: 'dispatchTime',
            type: 'time',
            startPlaceholder: '发车开始时间',
            endPlaceholder: '发车结束时间'
        },
        {
            name: '最新预警时间',
            value: 'requestReceiptTransferTime',
            value: 'newMonitorTime',
            type: 'time',
            startPlaceholder: '最新预警起始时间',
            endPlaceholder: '最新预警结束时间'
        },
        {
            name: '司机',
            type: 'advance',
            value: 'driver',
            multiple: true,
            border: true,
            dialogWidth: '800px',
            maxSelect: 5,
            multipleTableColumn: {
                prop: 'name', 'value': '司机名称'
            },
            advanceConfig: [
                { 'prop': 'name', 'value': '司机名称' },
                { 'prop': 'encuMobile', 'value': '司机电话' }
            ],
            tableConfig: [
                { 'prop': 'name', 'value': '司机名称' },
                { 'prop': 'encuMobile', 'value': '司机电话' }
            ],
            advanceUrl: 'suDriver/searchByConditions',
            cbParams: [
                'name#driver', 'encuMobile#driverContactWay'
            ]
        },
        {
            name: '承运商',
            advanceLabel: '承运商',
            value: 'carrierName',
            multiple: true,
            maxSelect: 5,
            multipleTableColumn: {
                prop: 'supplierNameCn', 'value': '承运商名称'
            },
            advanceConfig: [
                { prop: 'supplierNameCn', value: '承运商名称' },
                { prop: 'supplierCode', value: '承运商编码' }
            ],
            tableConfig: [
                { prop: 'supplierNameCn', value: '承运商名称' },
                { prop: 'supplierCode', value: '承运商编码' },
                { prop: 'transNameListStr', value: '采购渠道' }
            ],
            method: 'post',
            prefix: '/api-tms',
            advanceUrl: '/srm/supplier/search',
            type: 'advance',
            advanceNotSearch: true,
            queryConditionRequired: true,
            cbParams: ['supplierNameCn#carrierName', 'supplierCode#carrierCode', 'transTypeListStr#transType', 'transNameListStr#tranName'],
            advanceCascade: 'supplierCode#carrierCode'
        },
        {
            name: '采购渠道',
            value: 'procurementChannelList',
            optionNum: 'OTP_TMS_PROCUREMENT_CHANNEL',
            filterable: true,
            multiple: true,
            options: [],
            type: 'select'
        },
        {
            name: '车牌号',
            advanceLabel: '车牌号',
            value: 'vehicleCard',
            multiple: true,
            border: true,
            dialogWidth: '800px',
            maxSelect: 5,
            multipleTableColumn: {
                prop: 'licensePlateNumber', 'value': '车牌'
            },
            advanceConfig: [
                { prop: 'licensePlateNumber', value: '车牌' },
                { prop: 'cargoVolumeStr', value: '载货体积' },
                { prop: 'cdegNameCn', value: '车型' }
            ],
            tableConfig: [
                { prop: 'licensePlateNumber', value: '车牌' },
                { prop: 'cargoVolume', value: '载货体积' },
                { prop: 'cdegNameCn', value: '车型' }
            ],
            advanceUrl: 'suCar/searchByConditions',
            type: 'advance',
            cbParams: ['licensePlateNumber#vehicleCard'],
            advanceCascade: 'carrierCode#suppliersCode',
            unfold: true,
            span: 5
        },
        {
            name: '专业公司',
            value: 'professionalCompanyList',
            type: 'select',
            multiple: true,
            options: [],
            optionNum: 'JD_PROFESSIONAL_COMPANY'
        },
        {
            name: '调度人员',
            value: 'dispatchCreateUserName',
            type: 'input',
            span: 3,
            unfold: true,
            data: ''
        },
        {
            name: '行业',
            value: 'industryCategoryList',
            type: 'select',
            multiple: true,
            options: [],
            optionNum: 'SYS_SUPPLIER_INDUSTRY'
        }
    ],
    pickerConfig: {
        shortcuts: [{
                type: 'd',
                num: 6,
                text: '最近一周',
                translate: 'component.E202007300011'
            },
            {
                type: 'M',
                num: 1,
                text: '最近一个月',
                translate: 'component.E202007300013'
            },
            {
                type: 'M',
                num: 2,
                text: '最近两个月',
                translate: 'component.E1202104120940'
            },
            {
                type: 'M',
                text: '本月',
                toMonth: true,
                translate: 'component.E1202104120941'
            },
            {
                type: 'M',
                text: '上个月',
                lastMonth: true,
                translate: 'component.E1202104120942'
            }
        ]
    }
};
